<template>
    <div class="group-tecnologies" id="Technologies">
        <div class="group-up">
            <h1>Tecnologías</h1>
        </div>
        <div class="technologies-menu">
            <button class="menu-button" id="frontend" @click="type = 'frontend'" :class="{active: type === 'frontend'}">Frontend</button>
            <button class="menu-button" id="backend" @click="type = 'backend'" :class="{active: type === 'backend'}">Backend</button>
            <button class="menu-button" id="bbdd" @click="type = 'bbdd'" :class="{active: type === 'bbdd'}">BBDD</button>
            <button class="menu-button" id="version" @click="type = 'version'" :class="{active: type === 'version'}">Control de versiones</button>
            <button class="menu-button" id="testing" @click="type = 'testing'" :class="{active: type === 'testing'}">Testing</button>
            <button class="menu-button" id="ide" @click="type = 'ide'" :class="{ active: type === 'ide' }">IDE</button>
        </div>
        <div class="group-down">
            <transition name="fade" mode="out-in">
                <div key="frontend" v-if="type === 'frontend'" class="group-down-boxes">
                    <TecnologiesBox :img="htmlImg" title="HTML"></TecnologiesBox>
                    <TecnologiesBox :img="cssImg" title="CSS"></TecnologiesBox>
                    <TecnologiesBox :img="jsImg" title="JavaScript"></TecnologiesBox>
                    <TecnologiesBox :img="vueImg" title="Vue.js"></TecnologiesBox>
                    <TecnologiesBox :img="reactImg" title="React"></TecnologiesBox>
                    <TecnologiesBox :img="boostrapImg" title="Boostrap"></TecnologiesBox>
                </div>
                <div key="backend" v-else-if="type === 'backend'" class="group-down-boxes">
                    <TecnologiesBox :img="javaImg" title="Java"></TecnologiesBox>
                    <TecnologiesBox :img="pythonImg" title="Python"></TecnologiesBox>
                    <TecnologiesBox :img="phpImg" title="PHP"></TecnologiesBox>
                    <TecnologiesBox :img="springbootImg" title="Spring Boot"></TecnologiesBox>
                </div>
                <div key="bbdd" v-else-if="type === 'bbdd'" class="group-down-boxes">
                    <TecnologiesBox :img="mysqlImg" title="MySQL"></TecnologiesBox>
                    <TecnologiesBox :img="mongoImg" title="MongoDB"></TecnologiesBox>
                </div>
                <div key="version" v-else-if="type === 'version'" class="group-down-boxes">
                    <TecnologiesBox :img="jiraImg" title="Jira"></TecnologiesBox>
                    <TecnologiesBox :img="gitImg" title="Git"></TecnologiesBox>
                </div>
                <div key="testing" v-else-if="type === 'testing'" class="group-down-boxes">
                    <TecnologiesBox :img="jenkingImg" title="Jenkings"></TecnologiesBox>
                    <TecnologiesBox :img="jmeterImg" title="JMeter"></TecnologiesBox>
                    <TecnologiesBox :img="sonarImg" title="SonarQube"></TecnologiesBox>
                </div>
                <div key="ide" v-else-if="type === 'ide'" class="group-down-boxes">
                    <TecnologiesBox :img="visualImg" title="Visual Studio Code"></TecnologiesBox>
                    <TecnologiesBox :img="intellijImg" title="IntelliJ IDEA"></TecnologiesBox>
                    <TecnologiesBox :img="eclipseImg" title="Eclipse"></TecnologiesBox>
                </div>
            </transition>
        </div>
        
    </div>
</template>

<script>
    import TecnologiesBox from '../TecnologiesBox.vue';

    export default {
    name: 'App',
    components: {
    TecnologiesBox,
  },
    data() {
        return {
        type: 'frontend',

        htmlImg: require('../../assets/icons/frontend/icons8-html-5.svg'),
        cssImg: require('../../assets/icons/frontend/icons8-css.svg'),
        jsImg: require('../../assets/icons/frontend/icons8-javascript.svg'),
        vueImg: require('../../assets/icons/frontend/icons8-vuejs.svg'),
        reactImg: require('../../assets/icons/frontend/icons8-reaccionar-nativo.svg'),
        boostrapImg: require('../../assets/icons/frontend/icons8-oreja.svg'),

        javaImg: require('../../assets/icons/backend/icons8-java.svg'),
        pythonImg: require('../../assets/icons/backend/icons8-python.svg'),
        phpImg: require('../../assets/icons/backend/icons8-php.png'),
        springbootImg: require('../../assets/icons/backend/icons8-springboot.svg'),

        mysqlImg: require('../../assets/icons/bbdd/icons8-mysl.png'),
        mongoImg: require('../../assets/icons/bbdd/icons8-mongodb.png'),

        jiraImg: require('../../assets/icons/version/icons8-jira.svg'),
        gitImg: require('../../assets/icons/version/icons8-git.svg'),

        jenkingImg: require('../../assets/icons/testing/jenkins.png'),
        jmeterImg: require('../../assets/icons/testing/jmeter.svg'),
        sonarImg: require('../../assets/icons/testing/sonarqube.svg'),

        visualImg: require('../../assets/icons/ide/icons8-estudio-visual.svg'),
        eclipseImg: require('../../assets/icons/ide/icons8-eclipse.svg'),
        intellijImg: require('../../assets/icons/ide/icons8-intellij-idea.svg'),
        };
    },
}
</script>

<style scoped>
    .group-tecnologies{
        font-family: Roboto;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        background-color: #faf3e1;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .group-up{
        h1{
            font-size: 3em;
        }
    }
    .group-down{
        width: 60%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 4em;
    }

    .group-down-boxes{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        
        gap: 3em;
    }

    .technologies-menu{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1em;
    }

    .menu-button{
        width: 12em;
        height: 3.5em;
        border-radius: 5px;
        cursor: pointer;    
        border: 1.8px solid #0e0e0e;
        box-shadow: 1px 1px 0px 1px #0e0e0e;
    }



    #frontend{
        background-color: #FF9AA2;
    }

    #backend{
        background-color: #FFB7B2;
    }

    #bbdd{
        background-color: #FFDAC1;
    }

    #version{
        background-color: #E2F0CB;
    }

    #testing{
        background-color: #B5EAD7;
    }

    #ide{
        background-color: #C7CEEA;
    }

    .menu-button.active#frontend,
    .menu-button.active#backend,
    .menu-button.active#bbdd,
    .menu-button.active#version,
    .menu-button.active#testing,
    .menu-button.active#ide {
        background-color: #fdf9f8; /* Color más oscuro para el botón activo */
    }

</style>